module.exports = __webpack_public_path__ + "assets/img/facilities2.7eee87ad.png";